import { createSelector, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/app/store";
import { lastWeekRange, type DateRange } from "@/shared/lib/dateRange";

export type AnalyticsDevice = "all" | "desktop" | "mobile";
export const ANALYTICS_DEVICES: readonly AnalyticsDevice[] = ["all", "desktop", "mobile"];

export interface AnalyticsState {
  device: AnalyticsDevice;
  range: DateRange;
}

export interface AnalyticsFilters {
  device: AnalyticsDevice;
  date: DateRange;
}

/** Filtri della sezione Analytics (getAnalyticsSelectedDevice / getAnalyticsSelectedDate del legacy). */
export const analyticsSlice = createSlice({
  name: "analytics",
  initialState: (): AnalyticsState => ({ device: "all", range: lastWeekRange() }),
  reducers: {
    setDevice(state, action: PayloadAction<AnalyticsDevice>) {
      state.device = action.payload;
    },
    setRange(state, action: PayloadAction<DateRange>) {
      state.range = action.payload;
    },
  },
});
export const { setDevice, setRange } = analyticsSlice.actions;

export const selectAnalyticsDevice = (state: RootState) => state.analytics.device;
export const selectAnalyticsRange = (state: RootState) => state.analytics.range;
export const selectAnalyticsFilters = createSelector(
  [selectAnalyticsDevice, selectAnalyticsRange],
  (device, range): AnalyticsFilters => ({ device, date: range }),
);
